export default __webpack_public_path__ + "static/media/ipad_11.2b45d675.png";